// ppk's "Better modern input type detection"
// https://www.quirksmode.org/blog/archives/2015/03/better_modern_i.html
export default function supportsType(input) {
  var desiredType = input.getAttribute('type');
  var supported = false;
  if (input.type === desiredType) {
    supported = true;
  }
  input.value = 'Hello world';
  var helloWorldAccepted = (input.value === 'Hello world');
  switch (desiredType) {
    case "email":
    case "url":
      if (!input.validationMessage) {
        supported = false;
      }
      break;
    case "color":
    case "date":
    case "datetime":
    case "month":
    case "number":
    case "time":
    case "week":
      if (helloWorldAccepted) {
        supported = false;
      } 
      break;
  }
  input.value = '';
  return supported;
}



// WEBPACK FOOTER //
// ./js/supports-type.js